// Common icons
import logo from '../assets/icons/common/logo.png';
import handWave from '../assets/icons/common/wave-hand.svg';

// Social icons
import linkedin from '../assets/icons/social/linkedin.svg';
import github from '../assets/icons/social/github.svg';

// Experience icons
import awardIcon from '../assets/icons/experience/award.svg';
import projectsIcon from '../assets/icons/experience/projects.svg';
import webdevIcon from '../assets/icons/experience/webdev.svg';
import supportIcon from '../assets/icons/experience/support.svg';
import accordionIcon from '../assets/icons/experience/accordion.svg';

// Images - import directly from src/assets
import heroMain from '../assets/images/hero/hero-image.jpg';
import aboutProfile from '../assets/images/about/headshot.jpg';
// Project images
import project1 from '../assets/images/projects/project1.jpg';
import findocsRag from '../assets/images/projects/findocs_rag.jpg';
import pictomercHero from '../assets/images/projects/pictomerch_hero.jpg';
import portfolioWebsite from '../assets/images/projects/portfolio_website.jpg';
import foxconnPL from '../assets/images/projects/foxconn_p&l.png';

// Trusted by logos
import mercedesLogo from '../assets/icons/trusted-by/mercedes-benz-seeklogo.png';
import volkswagenLogo from '../assets/icons/trusted-by/volkswagen-logo.png';
import wsLogo from '../assets/icons/trusted-by/ws-logo.png';
import synergiesLogo from '../assets/icons/trusted-by/synergies-logo.png';
import foxconnLogo from '../assets/icons/trusted-by/foxconn-logo.png';
import geelyLogo from '../assets/icons/trusted-by/geely-logo.png';
import jmoLogo from '../assets/icons/trusted-by/jmo-logo.png';
import wisewayLogo from '../assets/icons/trusted-by/wiseway-logo.png';
import bmwLogo from '../assets/icons/trusted-by/bmw-logo.png';

export const images = {
  logo,
  icons: {
    handWave,
    social: {
      linkedin,
      github,
    },
    experience: {
      award: awardIcon,
      projects: projectsIcon,
      webdev: webdevIcon,
      support: supportIcon,
      accordion: accordionIcon
    }
  },
  hero: {
    mainImage: heroMain,
  },
  about: aboutProfile,
  projects: {
    project1,
    findocsRag,
    pictomercHero,
    portfolioWebsite,
    foxconnPL,
  },
  mercedesLogo,
  volkswagenLogo,
  wsLogo,
  synergiesLogo,
  foxconnLogo,
  geelyLogo,
  jmoLogo,
  wisewayLogo,
  bmwLogo,
};
